(function ( $ ) {
    (function () {
        if ($('#maps').length) {
            var activeCity = $('.city-select select').find('option:selected').val();
            var map = L.map('maps').setView($('.map-list[data-city= ' + activeCity + ']').data('cords'), 12);

            L.esri.basemapLayer('Streets').addTo(map);

            var icon = L.icon({
                iconUrl: '/images/map.svg',
                iconSize: [24, 24],
                iconAnchor: [7, 16],
                popupAnchor: [0, -11]
            });

            $('.map-list[data-city= ' + activeCity + '] .js-map-cords').each(function () {
                let cords = $(this).data('cords');
                L.marker(cords, {
                    icon: icon
                }).addTo(map);

            });


        // $('.js-map-cords').each(function() {
        //   let cords = $(this).data('cords');
        //   L.marker(cords, {
        //     icon: icon
        //   }).addTo(map);

        // });


            var counter = 1;

            $('.js-map-cords').click(function (e) {
                e.preventDefault();
                counter++;
                activeCity = $('.city-select select').find('option:selected').val();
                if ($(window).width() < 980) {
                    $('.map-location').fadeIn();
                }
                let cords = $(this).data('cords');
                $('.maps').remove();
                $('.map-location').append('<div id="map' + counter + '" class="maps"></div>')
                var map = L.map('map' + counter + '').setView(cords, 18);

                L.esri.basemapLayer('Streets').addTo(map);

                var icon = L.icon({
                    iconUrl: '/images/map.svg',
                    iconSize: [24, 24],
                    iconAnchor: [7, 16],
                    popupAnchor: [0, -11]
                });

                $('.map-list[data-city= ' + activeCity + '] .js-map-cords').each(function () {
                    let cords = $(this).data('cords');
                    L.marker(cords, {
                        icon: icon
                    }).addTo(map);

                });


            });

            $('.maps-close').click(function () {
                $('.map-location').fadeOut();
            });
        }
    }());
}( jQuery ));
